import { render, staticRenderFns } from "./FormQuote.vue?vue&type=template&id=55b0794e&scoped=true&"
import script from "./FormQuote.vue?vue&type=script&lang=js&"
export * from "./FormQuote.vue?vue&type=script&lang=js&"
import style0 from "./FormQuote.vue?vue&type=style&index=0&id=55b0794e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b0794e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VForm,VSelect,VTextField,VTextarea})
